import { Modal } from '../partials/modal';

export class Form {
  constructor(element, modalElement = 'g-modal') {
    this.form = document.querySelector(element);
    this.elementFocusClass = 'js-input-focus';
    this.modalClass = 'contact-form-modal';
    this.modal = new Modal(modalElement);
    this.modalElement = this.form && this.form.closest('.contact-form')?.querySelector(`.${this.modalClass}`);
  }

  init() {
    if (this.form) {
      this.inputsFocus();
      this.textAreasFocus();
    }

    if (this.modalElement) {
      this.handleSubmit(() => {
        this.modal.openModal();
        this.modal.closeModal();
      });
    }
  }

  handleSubmit(callback) {
    this.form &&
      this.form.addEventListener('wpcf7mailsent', (e) => {
        callback(e);
      });
  }

  textAreasFocus() {
    this.form.querySelectorAll('textarea').forEach((item) => {
      this.handlerFocus(item);
    });
  }

  validTypeInput(item) {
    return item.type === 'text' || item.type === 'email' || item.type === 'number' || item.type === 'tel';
  }

  inputsFocus() {
    this.form.querySelectorAll('input').forEach((item) => {
      if (this.validTypeInput(item)) {
        this.handlerFocus(item);
      }
    });
  }

  handlerFocus(element) {
    element &&
      element.addEventListener('focus', ({ target }) => {
        const targetElement = target.closest('.form-group');
        targetElement && targetElement.classList.add(this.elementFocusClass);
      });

    element &&
      element.addEventListener('focusout', ({ target }) => {
        if (!target.value) {
          const targetElement = target.closest('.form-group');
          targetElement && targetElement.classList.remove(this.elementFocusClass);
        }
      });
  }
}

const contactForm = new Form('.contact-form');
contactForm.init();
